
import { GenericEntityBase, KeyType } from "../../_models/GenericEntityBase";
import { IPropretyAttribute, IEntityMetaData } from "../../_models/IEntityMetaData";
import { PropretyAttributes, Validation, NestedProperty, NavigationProperty } from "../../decorators/EntityDecorators";
import { i18nFeature } from "./i18nFeature.model";
import { i18nPosTranslationOverride } from "./navigation-entities/i18nPosTranslationOverride.model";
import { i18nTranslation } from "./navigation-entities/i18nTranslation.model";
import { i18nTranslationOverride } from "./navigation-entities/i18nTranslationOverride.model";


export class i18nLabel extends GenericEntityBase<number> {
  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.KeyProperty,
      IPropretyAttribute.Readonly
    ]
  })
  id: number = GenericEntityBase.GetDefaultId(KeyType.number);

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  @Validation({ maxLength: 256 })
  label!: string;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  displayLabel!: string;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  type!: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  fK_i18nFeature!: number;

  @NestedProperty({ TargetType: i18nFeature })
  i18nFeature?: i18nFeature;

  @NavigationProperty({ TargetType: i18nTranslation })
  i18nTranslations?: i18nTranslation[];

  @NavigationProperty({ TargetType: i18nPosTranslationOverride })
  i18nPosTranslationOverrides?: i18nPosTranslationOverride[];

  @NavigationProperty({ TargetType: i18nTranslationOverride })
  i18nTranslationOverrides?: i18nTranslationOverride[];

  GetType(): IEntityMetaData {
    return i18nLabel.getMetaData();
  }
}
